import { indexes } from '@mab-common/utils'
import RecordTypes = indexes.RecordTypes

type TranslationFunction = (key: string) => string

export const getTitles = (type: RecordTypes, t: TranslationFunction) => {
  switch (type) {
    case RecordTypes.ARTIST:
      return t('artists')
    case RecordTypes.COLLECTION:
      return t('collections')
    case RecordTypes.ARTWORK:
      return t('artworks')
    case RecordTypes.ARTICLES:
      return t('articles')
    case RecordTypes.PODCASTS_AND_VIDEOS:
      return t('videoAndPodcast')
    case RecordTypes.PODCASTS:
      return t('podcasts')
    case RecordTypes.VIDEOS:
      return t('videos')
  }
}

export const typeMapper = (type: RecordTypes, t: TranslationFunction) => {
  switch (type) {
    case RecordTypes.ARTIST:
      return t('artist')
    case RecordTypes.COLLECTION:
      return t('artistCollection')
    case RecordTypes.ARTWORK:
      return t('artwork')
    case RecordTypes.ARTICLES:
      return t('article')
  }
}
